import {
    SET_WELCOME_MODAL,
    SET_CONTRACTOR_DATA,
    CHANGE_STATE,
    SET_SEARCH_ARRAY
} from '../actions/types';

const initialState = {
  contractorWelcome: false,
  searchDataArr: []
};

export default (state = initialState, action) => {
    switch (action.type) {
      case SET_WELCOME_MODAL: {
        return {
          ...state,
          ...action.payload
        };
      }
      case SET_CONTRACTOR_DATA: {
        let newState = {...state};
        const apiData = action.payload.apiData;
        newState.contractorList = apiData.data;
        newState.approvalPendingCount = apiData.approvalPendingCount;
        newState.pendingCount = apiData.pendingCount;
        newState.approvedCount = apiData.approvedCount;
        newState.payoutCount = apiData.payoutCount;
        newState.ongoingCount = apiData.ongoingCount;
        newState.permissionpendingCount = apiData.permissionpendingCount;
        newState.attemptedCount = apiData.attemptedCount;
        newState.followupCount = apiData.followupCount;
        newState.invalidCount = apiData.invalidCount;
        return newState;
      }
      case CHANGE_STATE: {
        return {
          ...state,
          ...action.payload
        };
      }
      case SET_SEARCH_ARRAY: {
        let newDummyState = {...state};
        newDummyState.searchDataArr = action.payload.data;
        return newDummyState;
      }
      default:
        return state;
    }
  };